import {
  getGroupOverridePerms,
  getGroupPerms,
  type Group,
} from '@seen/core/groups'
import type { Role } from '@seen/core/roles'
import { useMemo } from 'react'
import { useCurrentPractitioner } from '#src/hooks/useCurrentPractitioner.ts'
import { usePortalStore } from '#src/hooks/usePortalStore.ts'

export type PractitionerPerms = {
  groups: Group[]
  roles: Role[]
  isTech: boolean
  isMOE: boolean
  isIDT: boolean
  isAuditor: boolean
}

export function useCurrentPractitionerPerms(): PractitionerPerms {
  const practitioner = useCurrentPractitioner()
  const override = usePortalStore((state) => state.groupOverride)

  return useMemo(() => {
    const groups = practitioner.groups ?? []
    const perms = override
      ? getGroupOverridePerms(override)
      : getGroupPerms(groups)

    return {
      groups,
      roles: practitioner.roles ?? [],
      ...perms,
    }
  }, [override, practitioner])
}
